import { Utils } from "./utils";

export class ToastHelper{

    static show(message, type = "standard", closeTimeOut = null){
        var toastElement = Utils.getNS().store.appToast || null;
        if( toastElement !== null ){
            if( closeTimeOut !== null ){
                toastElement.show(message, type, closeTimeOut);
            }else{
                toastElement.show(message, type);
            }
        }else{
            return null;
        }
    }

    static clean(){
        var toastElement = Utils.getNS().store.appToast || null;
        if( toastElement !== null ){
            toastElement.clean();
        }else{
            return null;
        }
    }

    static hide(){
        var toastElement = Utils.getNS().store.appToast || null;
        if( toastElement !== null ){
            toastElement.hide();
        }else{
            return null;
        }
    }

    static getDomElement(){
        var toastElement = Utils.getNS().store.appToast || null;
        if( toastElement !== null ){
            return toastElement;
        }else{
            return null;
        }
    }
    
    static getInstance(){
        var toastElement = Utils.getNS().store.appToast || null;
        if( toastElement !== null ){
            return toastElement;
        }else{
            return null;
        }
    }

}